import { Component, inject } from '@angular/core';
import { DATE_TIME_FORMAT } from '@cl/shared/constants';
import { BaseModel } from '@cl/shared/models';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
    selector: 'cl-info-modal',
    standalone: false,
    templateUrl: './info-modal.component.html',
    styleUrl: './info-modal.component.less',
})
export class InfoModalComponent {
    DATE_TIME_FORMAT = DATE_TIME_FORMAT;
    readonly infoData: BaseModel = inject(NZ_MODAL_DATA);
}
